import { Tabs } from "antd";

import Users from "./Users";
import AppAdmin from "./AppAdmin";
import ActiveUsers from "./ActiveUsers";
import Settings from "./Settings";

const Administration = () => {
  const onChange = (key) => {
    // console.log(key);
  };

  return (
    <Tabs
      defaultActiveKey="1"
      items={[
        {
          key: "1",
          label: "Application Admin",
          children: <AppAdmin />,
        },
        {
          key: "2",
          label: "Users",
          children: <Users />,
        },
        {
          key: "3",
          label: "Active Users",
          children: <ActiveUsers />,
        },
        {
          key: "4",
          label: "Settings",
          children: <Settings />,
        }
      ]}
      centered
      onChange={onChange}
    />
  );
};

export default Administration;
